export * from './DataChartBarsXUpIcon';
export * from './DataChartBarsXUpIcon16Light';
export * from './DataChartBarsXUpIcon16Regular';
export * from './DataChartBarsXUpIcon16Solid';
export * from './DataChartBarsXUpIcon20Light';
export * from './DataChartBarsXUpIcon20Regular';
export * from './DataChartBarsXUpIcon20Solid';
export * from './DataChartBarsXUpIcon24Regular';
export * from './DataChartBarsXUpIcon24Solid';
export * from './DataChartBarsXUpIcon32Regular';
export * from './DataChartBarsXUpIcon64Regular';
